
<template>
    <div class="container-fluid inputscreen-ct">
        <logged-header :points="inputStage === 'goodbye' ? null : user.points" />
        <div v-show="inputStage === 'normal'" class="row justify-content-center title-ct hcol-9">
            <div class="col-12 text-center align-items-center" >
                <div class="arrow-ct">
                    <arrow-right />
                </div>
                <h1>{{$t('input_header')}}</h1>
                <div class="acceptable-input justify-content-center row">
                    <!-- <div class="col-4">
                        <div class="icon-ct">
                            <img :src="depositTypeImage('tetrapack', true)" alt="">
                        </div>
                        <p>{{$t('totals_tetrapacks')}}</p>
                    </div>
                    <div class="col-4">
                        <div class="icon-ct">
                            <img :src="depositTypeImage('can', true)" alt="">
                        </div>
                        <p>{{$t('totals_cans')}}</p>
                    </div>
                    <div class="col-4">
                        <div class="icon-ct">
                            <img :src="depositTypeImage('pet', true)" alt="">
                        </div>
                        <p>{{$t('totals_pets')}}</p>
                    </div> -->
                    <div class="col-4">
                        <div class="icon-ct">
                            <img v-if="depositTypeImage('vape', true)" :src="depositTypeImage('vape', true)" alt="">
                            <img v-else src="@/assets/img/icons/bg/vape.svg" alt="">
                            
                        </div>
                        <p>{{$t('totals_vapes')}}</p>
                    </div>
                    <div class="col-4">
                        <div class="icon-ct">
                            <img v-if="depositTypeImage('vape', true)" :src="depositTypeImage('vape_salt', true)" alt="">
                            <img v-else src="@/assets/img/icons/bg/vape_salt.svg" alt="">
                        </div>
                        <p>{{$t('totals_vape_salts')}}</p>
                    </div>
                    <div class="col-4">
                        <div class="icon-ct">
                            <img v-if="depositTypeImage('battery', true)" :src="depositTypeImage('battery', true)" alt="">
                            <img v-else src="@/assets/img/icons/bg/vape_salt.svg" alt="">
                        </div>
                        <p>{{$t('totals_batterys')}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-5">
                        <a class="btn mt-5 btn-lg py-4 px-5 btn-warning" href="#" @click="showTotal($event)">{{$t('end_session')}}</a>
                    </div>
                </div>
            </div>
        </div>

        <div :class="inputStage === 'addTrash' ? 'show trash-container' : 'trash-container'">
            <tetrapack :shown="trashActive.tetrapack" :value="values.tetrapack" />
            <can :shown="trashActive.can" :value="values.can" />
            <pet :shown="trashActive.pet" :value="values.pet" />
            <vape :shown="trashActive.vape" :value="values.vape" />
            <vape-salt :shown="trashActive.vape_salt" :value="values.vape_salt" />
            <input-anim-battery :shown="trashActive.battery" :value="values.battery" />
        </div>
        <goodbye-message :shown="inputStage === 'goodbye'" />
        <totals :shown="inputStage === 'totals'" :total-values="sessionTotals" :total-points="sessionPoints" :session-number="sessionNumber" @finishSession="finishSession()"/>
        <!-- <battery-notification :shown="trashActive.battery && !ending" /> -->
        <loading-spinner :shown="loading && !animating" />
        <template v-show="inputStage === 'returnItem' || inputStage === 'itemStuck'">
            <div class="container-fluid homescreen-ct">
                <div class="row justify-content-center error-ct hcol-9 pt-5">
                    <return-item :shown="inputStage === 'returnItem'" />
                    <item-stuck :shown="inputStage === 'itemStuck'" />
                </div>
            </div>
        </template>
        <welcome-message :shown="inputStage === 'start'" :name="user.name" />
    </div>
</template>

<script>
import LoggedHeader from '@/components/InputScreen/LoggedHeader';
import WelcomeMessage from '@/components/InputScreen/WelcomeMessage';
import GoodbyeMessage from '@/components/InputScreen/GoodbyeMessage';
import Totals from '@/components/InputScreen/Totals';
import Pet from '@/components/InputScreen/Pet';
import BatteryNotification from '@/components/InputScreen/BatteryNotification';
import LoadingSpinner from '@/components/InputScreen/LoadingSpinner';
import Tetrapack from '@/components/InputScreen/Tetra';
import Glassbottle from '@/components/InputScreen/GlassBottle';
import ReturnItem from '@/components/InputScreen/ReturnItem';
import ItemStuck from '@/components/InputScreen/ItemStuck';
import Can from '@/components/InputScreen/Can';
import Vape from '@/components/InputScreen/Vape';
import VapeSalt from '@/components/InputScreen/VapeSalt';
import InputAnimBattery from '@/components/InputScreen/InputAnimBattery';
import ArrowRight from '@/assets/img/arrow-right';
import Vue from 'vue';
import {preventDrag} from '@/assets/js/base';
import { mapGetters } from 'vuex';

export default {
  components: {
      LoggedHeader, WelcomeMessage, GoodbyeMessage,
      Totals, LoadingSpinner, ReturnItem, ItemStuck,
      ArrowRight,
      BatteryNotification, Can, Pet, Tetrapack, Glassbottle, Vape, VapeSalt, InputAnimBattery
  },
  props: [
      "addCan",
      "addTetrapack",
      "addPet",
      "addBattery",
      "addVape",
      "addVapeSalt",
      "returnItem",
      "itemStuck",
      "user",
      "sessionNumber",
      "values",
      "sessionTotals",
      "sessionPoints",
      "deviceReady",
      "itemFailed",
      "sessionTimeout"
  ],
  data () {
    return {
        inputStage: 'start',
        trashActive: {
            pet: false,
            tetrapack: false,
            can: false,
            vape: false,
            vape_salt: false,
            battery: false,
        },
        timeout: null,
        animating: false,
        waitStage: false,
        toError: false,
        loading: false,
        ending: false
    }
  },
  mounted () {
      preventDrag();
      let that = this;
      this.timeout = setTimeout(function(e) {
          Vue.set(that, 'inputStage', 'normal');
      }, 3000);
  },
  computed: {
    ...mapGetters('DepositTypes', ['depositTypeImage'])
  },
  methods: {
      preventRenderDrag() {
          preventDrag();
      },
      showTotal (e) {
          if (e) {
            e.preventDefault();
          }
          Vue.set(this, 'inputStage', 'totals');

          setTimeout(() => {
            this.$emit('sendFinish');
            Vue.set(this, 'ending', true);
          }, 2000);
      },
      finishSession () {
        let toError = false;
        if (this.toError) {
            toError = true;
            Vue.set(this, 'toError', false);
        }
        Vue.set(this, 'inputStage', 'goodbye');
        this.$emit('waitingForQr', toError);
      },
      animateItem(item) {
        Vue.set(this.trashActive, 'pet', false);
        Vue.set(this.trashActive, 'tetrapack', false);
        Vue.set(this.trashActive, 'can', false);
        Vue.set(this.trashActive, 'vape', false);
        Vue.set(this.trashActive, 'vape_salt', false);
        Vue.set(this.trashActive, 'battery', false);

          Vue.set(this, 'animating', true)
          if (this.timeout) {
              clearTimeout(this.timeout);
          }
        //   if (item === 'battery') {
        //       Vue.set(this.trashActive, item, true);
        //       Vue.set(this, 'waitStage', true);
        //   } else {
            let that = this;
            Vue.set(this, 'inputStage', 'addTrash');
            this.timeout = setTimeout(function (e) {
                Vue.set(that.trashActive, item, true);
                that.timeout = setTimeout(function (ee) {
                    Vue.set(that, 'waitStage', true);
                }, 1000);
            }, 100);
          //}
      },
      animateError() {
          Vue.set(this, 'animating', true);
          if (this.timeout) {
              clearTimeout(this.timeout);
          };
          Vue.set(this, 'inputStage', 'returnItem');
          let that = this;
          this.timeout = setTimeout(function (e) {
              Vue.set(that, 'waitStage', true);
          }, 2000);
      },

      animateStuck() {
        let that = this;
        //to launch the spinner for a short while
        Vue.set(this, 'animating', false);
        Vue.set(this, 'inputStage', 'itemStuck');
        Vue.set(this, 'loading', true);
        setTimeout(function (e) {
            Vue.set(that, 'loading', false);
            Vue.set(that, 'animating', true);
        }, 500);
        if (this.timeout) {
            clearTimeout(this.timeout);
        };
        this.timeout = setTimeout(function (e) {
            Vue.set(that, 'waitStage', true);
        }, 500);
      },

      resetView() {
          this.inputStage = 'start';
          this.trashActive = {
              pet: false,
              tetrapack: false,
              can: false,
              battery: false
          };
          Vue.set(this, 'ending', false);
      }
  },
  watch: {
      addCan: function (val, oldval) {
          if (val) {
            this.animateItem('can');
          }
      },
      addTetrapack: function (val, oldval) {
          if (val) {
            this.animateItem('tetrapack');
          }
      },
      addPet: function (val, oldval) {
          if (val) {
            this.animateItem('pet');
          }
      },
      addVape: function (val, oldval) {
          if (val) {
            this.animateItem('vape');
          }
      },
      addVapeSalt: function (val, oldval) {
          if (val) {
            this.animateItem('vape_salt');
          }
      },
      addBattery: function (val, oldVal) {
          if (val) {
              this.animateItem('battery');
          }
      },
      returnItem: function (val, oldVal) {
          if (val) {
              this.animateError();
          }
      },
      itemStuck: function (val, oldVal) {
          if (val) {
              this.animateStuck();
          }
      },
      sessionNumber: function (val, oldVal) {
          if (val) {
              this.resetView();
          }
      },
      inputStage: function (val, oldVal) {
          this.preventRenderDrag();
      },
      waitStage: function (val, oldVal) {
          if (val) {
              if (this.deviceReady) {
                Vue.set(this, 'inputStage', 'normal')
                Vue.set(this, 'trashActive', {pet: false, tetrapack: false, can: false, battery: this.trashActive.battery});
                Vue.set(this, 'waitStage', false);
                Vue.set(this, 'animating', false);
              }
          }
      },
      deviceReady: function (val, oldVal) {
          Vue.set(this, 'loading', !val);
          if (val) {
              if (this.waitStage) {
                Vue.set(this, 'inputStage', 'normal')
                Vue.set(this, 'trashActive', {pet: false, tetrapack: false, can: false, battery: this.trashActive.battery});
                Vue.set(this, 'waitStage', false);
                Vue.set(this, 'animating', false);
              }
          }
      },
      itemFailed: function (val, oldVal) {
          if (val) {
              this.toError = true;
              this.showTotal();
              this.$emit('sendFinish');
          }
      },
      sessionTimeout: function (val, oldVal) {
          if (val) {
              this.showTotal(false);
          }
      }
  }
}
</script>

<style scoped lang="scss">
.acceptable-input {
    margin-top: 2rem;
    
    .icon-ct img {
        width: 5.25rem;
    }
} 
</style>